import React from "react";

import { Omit } from "../../utils/types";

export interface IEditBasicInfoSharedState {
  readonly isPlayingAgeWarned: boolean;
  readonly isPregnantDateInvalid: boolean;
  readonly isPregnant: boolean;
  readonly isDancerMeasurementsVisible: boolean;
  readonly changeSharedState: (
    sharedState: Partial<IEditBasicInfoSharedState>,
    callback?: () => void
  ) => void;
  readonly isVisibleSection: (name: string) => boolean;
}

const BasicInfoSharedStateContext = React.createContext<
  Partial<IEditBasicInfoSharedState>
>({});

const EditBasicInfoSharedStateConsumer = BasicInfoSharedStateContext.Consumer;

export const EditBasicInfoSharedStateProvider =
  BasicInfoSharedStateContext.Provider;

export interface IEditBasicInfoContextProps {
  sharedState: IEditBasicInfoSharedState;
}

export function withEditBasicInfoContext<P extends IEditBasicInfoContextProps>(
  Component: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>
): React.FC<
  React.PropsWithChildren<Omit<P, keyof IEditBasicInfoContextProps>>
> {
  return function BoundComponent(
    props: Omit<P, keyof IEditBasicInfoContextProps>
  ) {
    return (
      <EditBasicInfoSharedStateConsumer>
        {(value) => {
          const newProps = {
            ...props,
            sharedState: value,
          } as any as P;

          return <Component {...newProps} />;
        }}
      </EditBasicInfoSharedStateConsumer>
    );
  };
}
